// extracted by mini-css-extract-plugin
export default {"grid":"style_grid__7qogm","imgThumbnail":"style_imgThumbnail__XsTCh","imgContainer":"style_imgContainer__0xdwj","title":"style_title__y9Uo8","td":"style_td__5zFAD"};